var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{attrs:{"app":""}},[_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',{domProps:{"textContent":_vm._s(_vm.mdiMenu)}})],1),_c('v-spacer'),_c('v-btn',{attrs:{"to":{ name: 'Profile' },"exact":"","icon":""}},[_c('v-icon',{domProps:{"textContent":_vm._s(_vm.mdiAccountCircle)}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }